<template>
    <div>
        <div class="dropdown flex items-center">
            <svg-icon @click="opened = !opened" icon="three-dots"
                      class="w-4 h-4 opacity-70 hover:opacity-100 cursor-pointer"></svg-icon>
            <div v-if="opened" v-click-outside="close" class="dropdown-popup -left-20 top-full">

                <div @click.prevent="toggleFavorite" class="dropdown-popup-item">
                    <svg-icon v-if="comment.favorite" icon="bookmark-check-fill"
                              class="w-3 h-3 shrink-0 text-red-500"></svg-icon>
                    <svg-icon v-else icon="bookmark" class="w-3 h-3 shrink-0"></svg-icon>
                    <div v-if="comment.favorite">Убрать из закладок</div>
                    <div v-else>Добавить в закладки</div>
                </div>

                <div v-if="comment.can_edit" @click.prevent="editComment" class="dropdown-popup-item">
                    <svg-icon icon="pencil-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Редактировать</div>
                </div>

                <div v-if="comment.can_complain" @click.prevent="complain" class="dropdown-popup-item">
                    <svg-icon icon="rat" set="local" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Пожаловаться</div>
                </div>

                <div @click.prevent="copyLink" class="dropdown-popup-item">
                    <svg-icon icon="share" set="local" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Копировать ссылку</div>
                </div>

                <div v-if="comment.can_pin" @click.prevent="pinComment" class="dropdown-popup-item">
                    <svg-icon icon="pin-angle-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div v-if="comment.is_pinned">Открепить коммент</div>
                    <div v-else>Закрепить коммент</div>
                </div>

                <div v-if="comment.can_ban" @click.prevent="warnUser"
                     class="dropdown-popup-item dropdown-popup-item-red">
                    <svg-icon icon="exclamation-triangle-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Предупредить</div>
                </div>

                <div v-if="comment.can_ban" @click.prevent="banUser"
                     class="dropdown-popup-item dropdown-popup-item-red">
                    <svg-icon icon="lock-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Забанить</div>
                </div>

                <div v-if="!comment.preview && !comment.is_deleted && comment.can_delete" @click.prevent="deleteComment"
                     class="dropdown-popup-item dropdown-popup-item-red">
                    <svg-icon icon="trash-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Удалить комментарий</div>
                </div>

                <div v-if="!comment.preview && !comment.is_deleted && comment.can_delete" @click.prevent="deleteBranch"
                     class="dropdown-popup-item dropdown-popup-item-red">
                    <svg-icon icon="trash-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Удалить ветку</div>
                </div>

                <div v-if="(comment.preview || comment.is_deleted) && comment.can_delete" @click.prevent="deleteComment"
                     class="dropdown-popup-item dropdown-popup-item-red">
                    <svg-icon icon="trash-fill" class="w-3 h-3 shrink-0"></svg-icon>
                    <div>Восстановить</div>
                </div>
            </div>
        </div>

        <input ref="copyInput" :value="comment.url" readonly class="w-0 h-0 absolute opacity-0 -left-full-top-full z-0">
        <complain-dialog ref="complainDialog"></complain-dialog>
        <ban-dialog v-if="comment.can_ban" ref="banDialog"></ban-dialog>
        <warn-dialog v-if="comment.can_ban" ref="warnDialog"></warn-dialog>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import ComplainDialog from "../partials/ComplainDialog";
import BanDialog from "../partials/BanDialog";
import WarnDialog from "../partials/WarnDialog";
import SvgIcon from "../partials/SvgIcon.vue";

export default {
	props: [
		'comment',
	],
	components: {
		SvgIcon,
		WarnDialog,
		BanDialog,
		ComplainDialog,
	},
	data() {
		return {
			opened: false,
		};
	},
	methods: {
		close() {
			this.opened = false;
		},
		toggleFavorite() {
			this.comment.favorite = !this.comment.favorite;
			this.$emit('commentUpdated', this.comment);

			Client.post('/api/v1.1/comments/' + this.comment.id + '/favorite')
				.then(response => {
					this.comment.favorite = response.data.favorite;
					this.$emit('commentUpdated', this.comment);
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Не удалось. Закладчика посадили',
					});
				});
		},
		editComment() {
			this.opened = false;
			this.$emit('toggleEdit');
		},
		deleteComment() {
			if (confirm('Точно удалить?')) {
				Client.delete('/api/v1.1/posts/' + this.comment.post_id + '/comments/' + this.comment.id)
					.then(response => {
						this.$emit('commentUpdated', response.data.data);
						this.opened = false;
					})
					.catch(error => {
						notify({
							type: 'error',
							text: 'Ошибка. Жаль',
						});
					});
			}
		},
		deleteBranch() {
			if (confirm('Точно удалить все ветку?')) {
				Client.delete('/api/v1.1/posts/' + this.comment.post_id + '/comments/' + this.comment.id + '?branch=1')
					.then(response => {
						this.$emit('commentUpdated', response.data.data);
						this.$emit('branchDeleted');
						this.opened = false;
					})
					.catch(error => {
						notify({
							type: 'error',
							text: 'Ошибка. Жаль',
						});
					});
			}
		},
		async pinComment() {
			Client
				.patch(
					'/api/v1.1/posts/' + this.comment.post_id + '/comments/' + this.comment.id + '/pin',
					{pin: !this.comment.is_pinned}
				)
				.then(response => {
					this.$emit('commentUpdated', response.data.data);
					notify({
						type: 'success',
						text: 'Готово!',
					});
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Чот не готово. Не повезло',
					});
				})
				.finally(() => {
					this.opened = false;
				});
		},

		async complain() {
			this.opened = false;
			this.$refs.complainDialog.show({
				title: 'Пожаловаться на комментарий',
				message: 'Укажите причину',
				okButton: 'Пожаловаться',
				isPrompt: true,
			}).then((data) => {
				Client.post('/api/v1.1/posts/' + this.comment.post_id + '/comments/' + this.comment.id + '/complain', {
					reason_id: data.reason_id,
					reason: data.reason,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Жалоба отправлена модераторам',
						});
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async banUser() {
			this.opened = false;
			this.$refs.banDialog.show({
				title: 'Забанить пользователя',
				okButton: 'Забанить',
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.comment.user_id + '/ban', {
					days: data.days,
					reason: data.reason,
					permanent: data.permanent,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был забанен',
						});
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async banUserShort() {
			this.opened = false;
			this.$refs.banDialog.show({
				title: 'Короткий бан',
				okButton: 'Остудить',
				days: false
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.comment.user_id + '/ban', {
					days: 1 / 8,
					reason: data.reason,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был временно забанен',
						});
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		async warnUser() {
			this.opened = false;
			this.$refs.warnDialog.show({
				title: 'Предупредить пользователя',
				okButton: 'Предупредить',
			}).then((data) => {
				Client.post('/api/v1.1/user/' + this.comment.user_id + '/warn', {
					message: data.message,
				})
					.then(response => {
						notify({
							type: 'success',
							text: 'Пользователь был предупрежден',
						});
					})
					.catch(error => {
					});
			}).catch(error => {
				console.log(error);
			});
		},
		copyLink() {
			if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
				window.navigator.clipboard.writeText(this.comment.url);
			} else {
				let tempInput = this.$refs.copyInput;
				tempInput.select();
				tempInput.setSelectionRange(0, 99999);
				document.execCommand('copy');
			}
			notify({
				type: 'success',
				text: 'Ссылка скопирована',
			});
		}
	}
}
</script>